<header
  *transloco="let t"
  class="border-b bg-white transition-colors md:bg-white/80 md:backdrop-blur"
  [class]="solid() ? 'border-slate-200' : 'border-transparent'"
>
  <nav class="mx-auto flex h-20 max-w-8xl items-center justify-between px-4 sm:px-6 lg:px-8">
    <!-- Brand -->
    <a routerLink="/" class="flex items-center gap-2" (click)="closeMenu()">
      <img
        src="/assets/images/logo.png"
        alt="Edutrip"
        class="h-20 w-40 rounded-lg object-contain"
      />
    </a>

    <!-- Desktop links -->
    <ul class="hidden items-center gap-1 md:flex">
      @for (link of links; track link.path) {
        <li>
          <a
            [routerLink]="link.path"
            routerLinkActive="text-accent-600"
            [routerLinkActiveOptions]="{ exact: link.path === '/' }"
            class="rounded-md px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:text-accent-600"
          >
            {{ t(link.labelKey) }}
          </a>
        </li>
      }
    </ul>

    <!-- Desktop CTA -->
    <a
      routerLink="/login"
      class="hidden rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-accent-600 md:inline-block"
    >
      {{ t('nav.login') }}
    </a>

    <!-- Mobile toggle -->
    <button
      type="button"
      class="inline-flex items-center justify-center rounded-md p-2 text-slate-600 hover:bg-slate-100 md:hidden"
      [attr.aria-expanded]="menuOpen()"
      aria-controls="mobile-menu"
      aria-label="Toggle navigation menu"
      (click)="toggleMenu()"
    >
      @if (menuOpen()) {
        <svg
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      } @else {
        <svg
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      }
    </button>
  </nav>

  <!-- Mobile menu -->
  @if (menuOpen()) {
    <div id="mobile-menu" class="border-t border-slate-200 bg-white md:hidden">
      <ul class="space-y-1 px-4 py-3">
        @for (link of links; track link.path) {
          <li>
            <a
              [routerLink]="link.path"
              routerLinkActive="bg-accent-50 text-accent-600"
              [routerLinkActiveOptions]="{ exact: link.path === '/' }"
              class="block rounded-md px-3 py-2 text-base font-medium text-slate-700 hover:bg-accent-50 hover:text-accent-600"
              (click)="closeMenu()"
            >
              {{ t(link.labelKey) }}
            </a>
          </li>
        }
        <li class="pt-2">
          <a
            routerLink="/login"
            class="block rounded-md bg-accent-500 px-3 py-2 text-center text-base font-semibold text-white hover:bg-accent-600"
            (click)="closeMenu()"
          >
            {{ t('nav.login') }}
          </a>
        </li>
      </ul>
    </div>
  }
</header>
